import store from "@/store";
import l10n from "@/services/l10n";

import { USER_GROUP_PERSON } from "@/constants";

export default ({ itemType, itemId, active = true }) => {
  return {
    active,
    authModal: true,
    title: l10n("COMPLAIN"),
    icon: "claim",
    accessLevel: [USER_GROUP_PERSON],
    action: async () => {
      await store.dispatch("modal/open", {
        name: "complain",
        data: { type: itemType, id: itemId }
      });
    }
  };
};
